import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import compose from 'recompose/compose';

import { Filter, DateRangeInput, AutocompleteInput } from '../_Components';

const VisorFilter = ({ queues = [], filterDefaultValues = {}, formValues = {}, ...props}) => (  
    <Filter filterValues={filterDefaultValues} form="visorFilter" {...props}>
        <DateRangeInput 
            source="interval"
            label={``}
            alwaysOn
            maxDate={new Date()}
        />
        <AutocompleteInput 
            source="queue"
            label={`Очереди`}
            options={queues}
            placeholder="Найти очередь"
            style={{ width: 250 }}
            alwaysOn
        />
    </Filter>
);



const mapStateToProps = (state) => {
    const { fetch } = state;
    const isSaving = fetch ? (fetch.creat>0 ? true : false) : false;
    var recordLiveValues = getFormValues('filterForm')(state);
    return { 
        formValues: recordLiveValues,
        isSaving
    };
};

export default  compose(
    connect(mapStateToProps),
    // withStyles(styles),
)(VisorFilter);